export { InternalControlPage as default } from '@/components/pages/Ir/Governance/InternalControl'
